export default class BinaDegerFilter {
    constructor(
        public yil: number,
        private kullanimSekliId: string,
        private insaatSinifiId: string | undefined) { }
}